import Environment from '@/sections/environment/summary/environment-summary-page.vue';
import EnvironmentHistory from '@/sections/environment/history/environment-history-page.vue';
import EnvironmentSchedule from '@/sections/environment/schedule/environment-schedule-dashboard.vue';
import EnvironmentScheduleCreateEditPage from '@/sections/environment/schedule/create-edit/environment-schedule-create-edit-page.vue';

export default [
	{
		name: 'environments-manager',
		path: '/environments',
		component: Environment,
		props: route => ({
			search: route.query.search || '',
			environmentId: route.query.environmentId || null,
			sortBy: route.query.sortBy || 'name',
			sortDirection: route.query.sortDirection || 'asc'
		}),
		meta: {
			permissions: ['environments.read']
		}
	},
	{
		name: 'environment-history',
		path: '/environments/:changedEntityId/history',
		props: route => ({
			orderBy: route.query.orderBy || 'timestamp',
			orderDirection: route.query.orderDirection || 'desc',
			search: route.query.search || '',
			minDatetime: route.query.minDatetime,
			maxDatetime: route.query.maxDatetime,
			changedByUserId: route.query.changedByUserId,
			changedEntityId: route.params.changedEntityId,
			recordStart: parseInt(route.query.recordStart) || 1,
			maxCount: parseInt(route.query.maxCount) || 10
		}),
		component: EnvironmentHistory,
		meta: {
			permissions: ['environments.read']
		}
	},
	{
		name: 'environment-schedule-dashboard',
		path: '/environments/schedule',
		component: EnvironmentSchedule,
		meta: {
			permissions: ['environments.read']
		}
	},
	{
		name: 'environment-schedule-create',
		path: '/environments/schedule/add',
		component: EnvironmentScheduleCreateEditPage,
		meta: {
			permissions: ['environments.read','environments.create']
		}
	},
	{
		name: 'environment-schedule-edit',
		path: '/environments/schedule/:id(\\d+)/edit',
		props: route => ({
			id: parseInt(route.params.id)
		}),
		component: EnvironmentScheduleCreateEditPage,
		meta: {
			permissions: ['environments.update']
		}
	},
	{
		name: 'environment-schedule-reschedule',
		path: '/environments/schedule/:id(\\d+)/copy',
		props: route => ({
			id: parseInt(route.params.id)
		}),
		component: EnvironmentScheduleCreateEditPage
	}
];
